import axios from "axios";
import { getRunMode, getUserInfoFromCookies, returnToLogin } from "../helpers/applicationHelpers";

const getAuthorizationHeader = () => {
  const userInfo = getUserInfoFromCookies();
  const runMode = process.env.RUN_MODE;
  if (!userInfo) {
    if (runMode !== "local") {
      returnToLogin();
    } else {
      throw new Error("Nenhuma sessão de usuário encontrada. Favor logar no Astrea");
    }
  }

  return userInfo.session;
};

const getBaseUrl = () => {
  return process.env.API_DOMAIN;
};

// Backend Instance with more configs.
export const axiosBackendInstance = axios.create({
  baseURL: getBaseUrl(),
  headers: {
    Authorization: getAuthorizationHeader(),
  },
});

// Interceptor na hora de mandar a request
// TODO: Colocar recuperação de token JWT aqui.
axiosBackendInstance.interceptors.request.use((config) => {
  const runMode = getRunMode();

  config.timeout = runMode === "homologation" ? 60000 : 30000;
  config.timeoutErrorMessage = "Servidor não está respondendo.";
  return config;
});

// Interceptor na hora de recuperar a response
axiosBackendInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const statusCode = error.response?.data?.statusCode ?? 500;

    switch (statusCode) {
      case 400:
        return Promise.reject(error);

      default:
        return Promise.reject(error);
    }
  }
);

// Default Instance with minimal config.
export const axiosDefaultInstance = axios.create({});
